import useInfrastructure from "hooks/useInfrastructure.hook";
import { on } from "infrastructure/eventHub";
import { useEffect, useState } from "react";

export function useChatPendingMessagesCount() {
  const { repositories } = useInfrastructure();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      const total = await repositories.conversations.getPendingMessagesCount();
      if (!cancelled) setCount(total);
    }

    load();

    const unsub = on("repository", "conversations", "updated", load);

    return () => {
      cancelled = true;
      unsub();
    };
  }, [repositories]);

  return count;
}
